<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <!--  -->
    <div class="topV">
      <div class="topbg"></div>
      <div class="top_box">
        <div class="currency_box form_box">
          <div class="video_box">
            <video controls
                   class="video"
                   :loop="true"
                   muted
                   :autoplay="true"
                   :src="videoUrl"></video>
          </div>
          <div class="form_content">
            <div style="margin:10px 0 20px 0;color:#DE1F26;font-weight: 600;font-size: 24px;">免费试学{{trialDayNum}}天</div>
            <el-form ref="form"
                     :model="form"
                     :rules="rules">
              <el-form-item prop="enterpriseName">
                <el-input placeholder="企业名称"
                          maxlength="30"
                          @input="form.enterpriseName = form.enterpriseName.replace(/\s+/g,'')"
                          v-model.trim="form.enterpriseName"></el-input>
              </el-form-item>
              <el-form-item prop="employeeNum">
                <el-input placeholder="员工人数"
                          @input="employeeNumChange"
                          type="number"
                          v-model.number="form.employeeNum"></el-input>
              </el-form-item>
              <el-form-item prop="userName">
                <el-input placeholder="您的称呼"
                          maxlength="10"
                          @input="form.userName = form.userName.replace(/\s+/g,'')"
                          v-model="form.userName"></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <el-input placeholder="联系电话"
                          maxlength="11"
                          v-model.trim="form.phone"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button style="width:100%;background-color: #DE1F26;height: 40px;"
                           type="primary"
                           @click="submitForm">立即申请</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="line"></div> -->
    <div class="channel_box">
      <div class="currency_box">
        <curTitle color="#000"
                  :data="{title:'全渠道培训场景',content:'覆盖企业培训场景，打造学习型组织'}"></curTitle>
      </div>
      <div class="currency_box">
        <channel></channel>
      </div>
    </div>
    <!-- 课程 -->
    <div class="curriculum_box"
         v-if="!showFlag">
      <div class="currency_boxs">
        <div v-for="item in 2 "
             :key="item">
          <div class="flexStart"> <img :src="item == 1?$imgUrl + 'OnlineBusinessSchool/icon_top.png': $imgUrl + 'OnlineBusinessSchool/icon_hot.png'"
                 alt=""> <span class="title font40"
                  style="margin-left:20px">{{item==1?'商学院系列课':'线上训练营'}}</span> </div>
          <curriculum-item v-if=" item == 1 && oneDataShow"
                           :data="oneData"
                           status="more"></curriculum-item>
          <curriculum-item v-if=" item != 1 && twoDataShow"
                           :data="twoData"
                           status="more"></curriculum-item>
        </div>
      </div>
    </div>
    <!-- 线上商学院介绍 -->
    <div class="online_box">
      <div class="currency_box"
           style="margin-bottom:20px">
        <curTitle color="#000"
                  :data="{title:'线上商学院',content:'数字平台+零售系列课+代运营服务三位一体'}"></curTitle>
      </div>
      <div class="currency_box"
           v-for="(item,index) in contentList"
           :key="index">
        <el-image v-if="item.resourceType == 1"
                  style="width:100%;cursor: pointer;"
                  @click="$Public.link(item)"
                  :src="item.resourceUrl"></el-image>
        <video v-if="item.resourceType == 2"
               class="video"
               muted
               style="width:100%;height:100%"
               :controls="true"
               :autoplay="false"
               :src="item.resourceUrl"></video>
      </div>
    </div>
  </div>
</template>

<script>
import curriculumItem from '@/components/OnlineBusinessSchool/curriculum_item.vue'
import channel from '@/components/OnlineBusinessSchool/channel.vue'
import curTitle from '@/components/home/cur_title.vue'
import { formAddApply, courseList, resourceList, trialDay, getLatestVersion_v2 } from '@/api/api.js'
export default {
  components: { curriculumItem, curTitle, channel },
  data () {
    const validateMobile = (rule, value, callback) => {
      let regPhone = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
      if (value === '') {
        callback(new Error('请填写您的手机号'));
      } else if (!regPhone.test(value)) {
        callback(new Error('请输入正确的手机号格式!'));
      } else {
        callback();
      }
    };
    var validateTitle = (rule, value, callback) => {
      const reg = /^[a-zA-Z\u4e00-\u9fa5]+$/
      if (!reg.test(value)) {
        callback(new Error('只允许填写汉字、字母'))
      } else {
        callback()
      }
    }
    return {
      showFlag: false,
      contentList: [], //底部内容配置图
      rules: {
        userName: [
          { required: true, message: '请输入您的称呼', trigger: 'blur' },
        ],
        phone: [
          { validator: validateMobile, trigger: 'blur' }
        ],
        enterpriseName: [
          { required: true, message: '请输入您的企业名称', trigger: 'blur' }
        ],
        employeeNum: [
          { required: true, message: '请输入您的企业员工人数', trigger: 'blur' }
        ]
      },
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800',
      videoUrl: '',
      oneData: {},
      oneDataShow: false,
      twoDataShow: false,
      twoData: {},
      form: {
        miniType: '2',
        fromType: '1',
        enterpriseName: '',
        employeeNum: '',
        userName: '',
        phone: ''
      },
      trialDayNum: 1,
      data: {
        showIndex: 2,
        pageNumber: 1,
        pageSize: 100,
      }
    }
  },
  created () {
    this.getLatestVersion_v2();
    this.getresourceList(2)
    this.getresourceList(9)
    this.gettrialDay();
  },
  methods: {
    async getLatestVersion_v2 () {
      let data = {
        terminal: 'ios',
      }
      const res = await getLatestVersion_v2(data);
      if (res.code <= 200) {
        if (res.data) {
          this.showFlag = true;
        } else {
          this.showFlag = false;
          this.getcourseList(1)
          this.getcourseList(2)
        }
      } else {
        this.showFlag = true;
      }
    },
    async gettrialDay () {
      const res = await trialDay()
      this.trialDayNum = res.data
    },
    employeeNumChange (e) {
      let num = e.replace(".", "")
      console.log(num)
      this.form.employeeNum = num;
      if (Number(num) <= 0) {
        this.form.employeeNum = 1;
      }
      if (Number(num) >= 99999) {
        this.form.employeeNum = 99999;
      }
    },
    async getresourceList (type) {  //获取资源
      this.data.showIndex = type
      const res = await resourceList(this.data)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      console.log(res)
      if (type == 2) {
        this.videoUrl = res.data[0].resourceUrl
      } else if (type == 9) {
        this.contentList = res.data;
      }

    },
    submitForm () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.getFormAddApply()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    toStatus () {
      this.getFormAddApply()
      // this.$router.push('/Status')
    },
    getFormAddApply () {
      formAddApply(this.form).then(res => {
        if (res && res.code == 401) {
          this.$refs.topNav.login()
          return
        }
        if (res && res.code == 200) {
          this.$router.push('/Status?type=15')
        }
      })
    },
    async getcourseList (type) {
      let data = {
        courseType: type,
        pageNumber: 1,
        pageSize: 8

      }
      const res = await courseList(data)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      if (type == 1) {
        this.oneData = { ...res.data, ...{ bg: '#F5F5F5', itembg: '#fff', status: 'more' } }
        this.oneDataShow = true;
      } else {
        this.twoData = { ...res.data, ...{ bg: '#F5F5F5', itembg: '#fff', status: 'more' } }
        this.twoDataShow = true;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  min-height: 100vh;
  width: 100%;
  background-color: #f5f5f5;
  .topV {
    position: relative;
    min-width: 1200px;
    height: 463px;
    .topbg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 79px;
      background: linear-gradient(0deg, #f5f5f5, #ffedee);
    }
    .top_box {
      min-width: 1200px;
      display: flex;
      justify-content: center;
      height: 100%;
      .form_box {
        padding: 30px 0;
        box-sizing: border-box;
        height: 100%;
        z-index: 1;
        // background-color: #fff;
        .video_box {
          flex: 1;
          height: 100%;
          margin-right: 20px;
          .video {
            width: 100%;
            height: 100%;
            object-fit: fill;
          }
        }
        .form_content {
          text-align: left;
          width: 330px;
          background-color: #ffffff;
          height: 100%;
          padding: 20px;
          box-sizing: border-box;
        }
      }
    }
  }
  .online_box {
    background-color: #fff;
    min-width: 1200px;
    padding: 50px 0;
    box-sizing: border-box;
  }
  .curriculum_box {
    width: 100%;
    background-color: #f5f5f5;
    margin-top: 60px;
  }
  .channel_box {
    // padding: 0 20px;
    // box-sizing: border-box;
    min-width: 1200px;
    height: 630px;
    padding-top: 50px;
    background-color: #fff;
  }
}
</style>
